function normalizeRoadWays(data) {
  if (!data || typeof data !== 'object') {
    return []
  }

  return ['inRoadWays', 'outRoadWays']
    .reduce((result, key) => result.concat(Array.isArray(data[key]) ? data[key] : []), [])
    .filter(roadWay => roadWay && roadWay.laneCode)
}

function buildBarrierOperationParams({ parkId, laneCode, operType }) {
  const parsedParkId = Number(parkId)
  if (!Number.isInteger(parsedParkId) || !laneCode || ![0, 1].includes(operType)) {
    throw new Error('道闸操作参数有误')
  }
  return {
    parkId: parsedParkId,
    laneCode,
    operType
  }
}

function isBarrierOperationSuccessful(result) {
  return Boolean(result && result.code === '000000')
}

function getBarrierParkName(parkId) {
  const parkNames = {
    31: '明波车场'
  }
  return parkNames[Number(parkId)] || `车场 ${parkId}`
}

module.exports = {
  normalizeRoadWays,
  buildBarrierOperationParams,
  isBarrierOperationSuccessful,
  getBarrierParkName
}
